import { ChangeDetectorRef, Component, inject } from '@angular/core';

import { LetDirective } from '@ngrx/component';

import type { StaticInputsComponent } from '@recruitee/common';
import { RtComponentOutlet } from '@recruitee/common';
import { injectUntilDestroyed } from '@recruitee/utils';

import { ExpandableCellService } from './expandable-cell.service';
import { ButtonComponent } from '../../../common/button/components/button/button.component';
import { TruncateComponent } from '../../../common/truncate/truncate.component';
import type { TableCellFactoryResult } from '../../data-table.types';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [ButtonComponent, TruncateComponent, RtComponentOutlet, LetDirective],
  template: `
    <ng-container *ngrxLet="componentOutletConfig; let config">
      <ng-template
        [rtComponentOutlet]="config.component"
        [rtComponentOutletInputs]="config.inputs"
      />
    </ng-container>
    @if (allLength > shortLength) {
      <rt-button
        variant="outline"
        margin-tb-small
        (click)="$event.stopPropagation(); toggleExpand()"
      >
        <rt-truncate>
          {{ isExpanded ? collapseLabel : expandLabel }}
        </rt-truncate>
      </rt-button>
    }
  `,
  inputs: ExpandableCellComponent.NgInputs,
})
export class ExpandableCellComponent {
  public static NgInputs = [
    'id' as const,
    'columnId' as const,
    'all' as const,
    'allLength' as const,
    'short' as const,
    'shortLength' as const,
    'componentOutletConfigFactory' as const,
    'expandLabel' as const,
    'collapseLabel' as const,
    'group' as const,
  ];

  public id: number;
  public columnId: string;
  public all: unknown[];
  public allLength: number;
  public short: unknown[];
  public shortLength: number;
  public componentOutletConfigFactory: (
    isExpanded: boolean,
  ) => TableCellFactoryResult<StaticInputsComponent>;
  public expandLabel: string;
  public collapseLabel: string;
  public group: string;

  protected componentOutletConfig: TableCellFactoryResult<StaticInputsComponent>;
  protected isExpanded = false;

  private cdRef = inject(ChangeDetectorRef);
  private expandableCellService = inject(ExpandableCellService);
  private untilDestroyed = injectUntilDestroyed();

  public ngOnInit() {
    this.updateOutletConfig();

    this.expandableCellService.expandedGroups$.pipe(this.untilDestroyed).subscribe(groups => {
      this.isExpanded = groups[this.group] ?? false;
      this.updateOutletConfig();
    });
  }

  public toggleExpand() {
    this.isExpanded = !this.isExpanded;
    this.expandableCellService.toggleGroup(this.group, this.isExpanded);
  }

  private updateOutletConfig() {
    this.componentOutletConfig = this.componentOutletConfigFactory(this.isExpanded);
    this.cdRef.detectChanges();
  }
}
